export default __webpack_public_path__ + "static/media/yii.5bb99178.svg";